import React from "react";
import User from "../components/User";
export default function Dashboard() {
    return (
        <>
            <User />
        </>
    )
}